<template>
  <span></span>
</template>

<script>
export default {
  name: "RedirectToCharidy",
  mounted() {
    window.location.href = "https://www.charidy.com/dllink";
  },
}
</script>

<style scoped>
</style>
